import { Button, VStack } from '@chakra-ui/react'
import React from 'react'
import { BsBookmarks } from 'react-icons/bs'
import { useSelectedItemAlertContext, itemData } from '../../context/selectedItemAlertContext'
import { useUserContext } from '../../context/userContext'

const ManualList = () => {
    const { setItemData } = useSelectedItemAlertContext()
    const { userData } = useUserContext()

    return (
        <VStack w="full" align="start">
            <Button variant="link" leftIcon={<BsBookmarks />} onClick={() => setItemData(itemData(1, 'doc/manual_user.pdf'))} >คู่มือการใช้งานโปรแกรม สำหรับผู้ใช้งาน</Button>
            {
                userData.isAcceptRoles([1, 2]) &&
                <Button variant="link" leftIcon={<BsBookmarks />} onClick={() => setItemData(itemData(2, 'doc/manual_admin.pdf'))}>คู่มือการใช้งานโปรแกรม สำหรับเจ้าหน้าที่กองสวัสดิการ</Button>
            }
        </VStack>
    )
}

export default ManualList
